import React from 'react';
import { numberWithCommas } from '../../AppUtil/AppUtil';
import Error from '../Home/Error';

export default function UserBalanceHeader({ user = '', balance = 0, classContainer = '', error = '' }) {
	return (
		<div className={classContainer}>
			<h3 className="dashboard-welcome-header">
				Welcome, <span className="dashboard-welcome-user">{user}</span>
			</h3>

			<div className="dashboard-welcome-balance">
				<p className="dashboard-welcome-text">₱{numberWithCommas(balance)}</p>
				<p className="dashboard-welcome-text">Wallet Balance</p>
			</div>

			<Error error={error}/>
			
		</div>
	);
}
